import React from 'react';
import { useApp } from '../hooks/useApp';
import Lobby from '../components/Lobby';
import { useWalletConnection } from '../hooks/queries';
import { useConnectWallet, useDisconnectWallet } from '../hooks/mutations';

const LobbyPage = () => {
  const {
    username,
    setUsername,
    currentRoom,
    setCurrentRoom,
    joinGame,
    connectionStatus,
  } = useApp();

  // React Query hooks
  const { data: walletData, isLoading: isWalletLoading } = useWalletConnection();
  const connectWalletMutation = useConnectWallet();
  const disconnectWalletMutation = useDisconnectWallet();

  // Pass data and functions to the Lobby component
  return (
    <Lobby
      username={username}
      setUsername={setUsername}
      currentRoom={currentRoom}
      setCurrentRoom={setCurrentRoom}
      onJoinGame={joinGame}
      connectionStatus={connectionStatus}
      // Wallet data
      walletData={walletData}
      isWalletLoading={isWalletLoading}
      connectWallet={connectWalletMutation.mutate}
      disconnectWallet={disconnectWalletMutation.mutate}
      isConnecting={connectWalletMutation.isPending}
      isDisconnecting={disconnectWalletMutation.isPending}
    />
  );
};

export default LobbyPage;